export default __webpack_public_path__ + "8a710e77e5d037fe3dd3417b5a889872.png";